import BaseModel from './BaseModel'
import moment from 'moment'
import {currentConseillerId} from '@/helpers'

export default class EssaiModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      ID_PROSPECT: null,
      ID_CONTACT: null,
      ID_CONSEILLER: currentConseillerId(),
      ID_COPROPRIETE: '',
      ID_COPROPRIETE_MODELE: '',
      VERSION_ESSAI: 2,
      DATE_DEBUT_ESSAI: moment().format('DD/MM/YYYY'),
      DATE_FIN_ESSAI: moment().add(30, 'days').format('DD/MM/YYYY'),
      CODE_REF_STATUT_ESSAI: '0',
      COMMENTAIRES: ''
    }
    super(data, relation, fields)
  }
}
